export {
    Type,
    fromJSON,
    JSON_DISCRIMINATOR,
    Serializable,
    toTypedJSON,
    toUnwrappedJSON,
    fromUnwrappedJSON,
    fromTypedJSON,
    instanceOf,
    create,
    equals,
    toSerializable,
    fromSerializable,
} from '../../types/SequenceNumber.js';
